export default "__VITE_ASSET__J3mnZNS5__"